
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const stats = [
    { number: '500+', label: 'Projects Delivered' },
    { number: '150+', label: 'Happy Clients' },
    { number: '15+', label: 'Years Experience' },
    { number: '50+', label: 'Expert Consultants' }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Leading IT Innovation for Over 15 Years
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              TechServe has been at the forefront of IT consulting and digital transformation, helping businesses across industries leverage technology to achieve their strategic goals. Our team of certified professionals brings deep expertise in cloud computing, cybersecurity, software development, and emerging technologies.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We partner with organizations of all sizes - from startups to Fortune 500 companies - providing tailored solutions that drive innovation, improve efficiency, and accelerate growth in today's rapidly evolving digital landscape.
            </p>
            
            <div className="grid grid-cols-2 gap-6 mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">{stat.number}</div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
            
            <Button variant="primary" size="lg">
              <i className="ri-team-line mr-2"></i>
              Meet Our Team
            </Button>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/b5048cabcd1030a23b44af326152ad9c.jpg"
              alt="TechServe team working together" 
              className="rounded-lg shadow-2xl object-cover w-full h-96"
            />
            <div className="absolute -bottom-6 -left-6 bg-blue-600 text-white p-6 rounded-lg shadow-lg">
              <div className="text-2xl font-bold">98%</div>
              <div className="text-sm">Client Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
